import RealTippy from '@tippyjs/react';

import 'tippy.js/dist/tippy.css';

export * from '@tippyjs/react';

export const Tippy = RealTippy;
